export const PLANNING_TIME_SUGGESTIONS_MINUTES = [15, 30, 45, 60, 75, 90, 120, 150, 180, 240, 360]
export const PLANNING_ASSIGNMENT_OFFSET_SUGGESTIONS_MINUTES = [0, ...PLANNING_TIME_SUGGESTIONS_MINUTES]

export const formatPlanningMinutes = value => {
  if (value === null || value === undefined || value === '') {
    return ''
  }

  const minutes = Number(value)
  if (!Number.isFinite(minutes) || minutes < 0) {
    return ''
  }

  const hoursPart = String(Math.floor(minutes / 60)).padStart(2, '0')
  const minutesPart = String(minutes % 60).padStart(2, '0')

  return `${hoursPart}:${minutesPart}`
}

export const parsePlanningMinutesInput = value => {
  if (typeof value !== 'string') {
    return null
  }

  const trimmedValue = value.trim()
  const colonMatched = trimmedValue.match(/^(\d{1,3}):([0-5]\d)$/)
  if (colonMatched) {
    return (Number(colonMatched[1]) * 60) + Number(colonMatched[2])
  }

  if (!/^\d+$/.test(trimmedValue)) {
    return null
  }

  if (trimmedValue.length <= 2) {
    return Number(trimmedValue)
  }

  const minutesPart = trimmedValue.slice(-2)
  const hoursPart = trimmedValue.slice(0, -2)
  const minutes = Number(minutesPart)
  if (minutes > 59) {
    return null
  }

  return (Number(hoursPart) * 60) + minutes
}

export const normalizePlanningTimeInput = value => {
  const parsedValue = parsePlanningMinutesInput(value)

  return {
    parsedValue,
    normalizedValue: parsedValue === null ? value : formatPlanningMinutes(parsedValue),
  }
}

export const getPlanningAssignmentOffsetOptions = formatFn => PLANNING_ASSIGNMENT_OFFSET_SUGGESTIONS_MINUTES
  .map(formatFn)
  .filter(Boolean)
